import useUserLogs from 'hooks/useUserLogs';
import config from '../../../oktaConfig';
import {useState, useEffect} from 'react';
import {useOktaAuth} from '@okta/okta-react';
import DevicesResponse from '../interfaces/DevicesResponse';

function useInventories() {
  const {authState, oktaAuth} = useOktaAuth();
  const [data, setData] = useState<DevicesResponse[]>([]);
  const [pending, setPending] = useState<boolean>(true);
  const [error, setError] = useState<any | null>(null);
  const {dispatch: dispatchUserLog} = useUserLogs();

  useEffect(() => {
    const controller = new AbortController();
    async function startFetch({controller}: {controller: AbortController}) {
      setData([]);
      setError(null);
      setPending(true);
      const accessToken = oktaAuth.getAccessToken();
      const results = await fetch(config.resourceServer.insightsApiUrlDevices, {
        mode: 'cors',
        credentials: 'include',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        signal: controller.signal,
      })
        .then(response => {
          if (!response.ok) {
            return Promise.reject(response);
          }
          return response.json();
        })
        .catch(err => {
          console.log('error', err);
          setError(err);
        });

      if (!ignore) {
        setData(results);
        setPending(false);
        dispatchUserLog('Device Inventory');
      }
    }

    let ignore = false;

    if (authState && authState.isAuthenticated) {
      startFetch({controller});
    }

    return () => {
      ignore = true;
      controller.abort();
    };
  }, [authState, oktaAuth]);

  return {data, pending, error};
}

export default useInventories;
